import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'

import { CrudStore } from 'core/types/crudStore'
import { TLNRForm } from 'onboarding/components/widgets/public/forms/lnr/models'

export enum LNRFormCacheKey {
  lnrForm = 'lnrForm',
}

class LNRFormApi {
  public getCrud(cacheKey?: LNRFormCacheKey) {
    return CrudStore.get(CrudStoreItemOnboarding.LNRFormData, cacheKey)
  }

  public fetchByRequestId(requestId: number, cacheKey?: LNRFormCacheKey): Promise<TLNRForm | null> {
    return this.getCrud(cacheKey).getById({ id: requestId, force: true, keyField: 'RequestId' })
  }
}

export const lnrFormApi = new LNRFormApi()
